export const FETCH_STATUS = {
  NEW: 0,
  CONTRACT: 1,
  PRODUCTION: 2,
  PRODUCED: 3,
  DELIVERY: 4,
  CLEAR: 5,
  CONCLUDED_NOT_BILLED: 102,
} as const;
